import React from 'react'
const VideoControlled = ({ videoSrcURL, videoTitle, ...props }) => (
  <div className='video'>
    <video muted autoPlay controls>
      <source src={videoSrcURL} type="video/mp4" />
    </video>
  </div>
)
export default VideoControlled